import { render, staticRenderFns } from "./downloadChoice.vue?vue&type=template&id=8206818e&scoped=true&"
import script from "./downloadChoice.vue?vue&type=script&lang=js&"
export * from "./downloadChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8206818e",
  null
  
)

export default component.exports